import type { DayState } from '@daily/shared';

export interface DayStateTheme {
  bentoGradient: string;
  ambientGradient: string;
}

export const dayStateTheme: Record<DayState, DayStateTheme> = {
  morning: {
    bentoGradient: 'linear-gradient(135deg, #FFF1DF 0%, #FFE4D0 40%, #FFD9C2 100%)',
    ambientGradient:
      'radial-gradient(ellipse 800px 600px at 12% 8%, rgba(255,176,136,0.32), transparent 70%),' +
      'radial-gradient(ellipse 700px 500px at 95% 18%, rgba(233,75,107,0.18), transparent 70%),' +
      'radial-gradient(ellipse 900px 700px at 80% 90%, rgba(107,140,94,0.22), transparent 70%),' +
      'radial-gradient(ellipse 600px 400px at 5% 70%, rgba(232,163,58,0.18), transparent 70%)',
  },
  afternoon: {
    bentoGradient: 'linear-gradient(135deg, #FFF7E0 0%, #FFE9CE 50%, #FFD580 100%)',
    ambientGradient:
      'radial-gradient(ellipse 900px 600px at 50% 10%, rgba(255,213,128,0.38), transparent 65%),' +
      'radial-gradient(ellipse 700px 500px at 12% 80%, rgba(232,163,58,0.22), transparent 65%),' +
      'radial-gradient(ellipse 700px 500px at 90% 90%, rgba(255,176,136,0.22), transparent 70%)',
  },
  evening: {
    bentoGradient: 'linear-gradient(135deg, #FFE4D0 0%, #FFCEC1 50%, #F8B6C2 100%)',
    ambientGradient:
      'radial-gradient(ellipse 800px 600px at 18% 15%, rgba(233,75,107,0.25), transparent 70%),' +
      'radial-gradient(ellipse 700px 500px at 92% 20%, rgba(91,42,74,0.18), transparent 70%),' +
      'radial-gradient(ellipse 900px 700px at 50% 100%, rgba(201,87,45,0.22), transparent 65%)',
  },
  night: {
    bentoGradient: 'linear-gradient(135deg, #1F2D44 0%, #0F1419 60%, #0a0d18 100%)',
    ambientGradient:
      'radial-gradient(ellipse 800px 600px at 70% 18%, rgba(91,42,74,0.45), transparent 60%),' +
      'radial-gradient(ellipse 700px 500px at 30% 80%, rgba(31,45,68,0.5), transparent 60%)',
  },
};
